
import { mapActions, mapGetters } from 'vuex'
import SlideShow from '~/components/SlideShow'
import BreadCrumbs from '~/components/BreadCrumbs'
import ModalProducts from '~/components/ModalProducts'
import AttributesCheckbox from '~/components/AttributesCheckbox'
export default {
  name: 'ProductDetailsPage',
  components: {
    AttributesCheckbox,
    ModalProducts,
    BreadCrumbs,
    SlideShow
  },
  async fetch () {
    this.product = await this.$axios.get(`/products/${this.product.id}`).then((res) => {
      return res.data
    })
    if (this.checkProd(this.product)) {
      this.$store.commit('cart/UPD_PRODUCT_IN_CART', { item: this.product })
    }
  },
  data () {
    return {
      timeOut: null,
      elements: [
        {
          title: 'Inicio',
          name: 'index',
          params: ''
        },
        {
          title: 'Productos',
          name: 'products',
          params: ''
        }
      ],
      categoryName: '',
      product: {
        id: null,
        special: '',
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      checkProd: 'cart/checkProd',
      prodPrice: 'cart/prodPrice',
      getRealPrice: 'getRealPrice'
    })
    // imgs () {
    //   if (Object.prototype.hasOwnProperty.call(this.product, 'images')) {
    //     return this.product.images.length > 2 ? this.product.images : [this.product.image]
    //   }
    //   return []
    // }
  },
  activated () {
    if (this.$fetchState.timestamp <= Date.now() - 360000) {
      this.$fetch()
    }
  },
  created () {
    // console.log(this.$route)
    this.product.id = this.$route.params.id
    if (this.$route.params.category) {
      this.categoryName = this.passName(this.$route.params.category).toUpperCase()
      this.elements.push({
        title: this.passName(this.$route.params.category),
        name: 'products-category',
        params: { idCat: this.$route.params.idCat, category: this.$route.params.category }
      })
    }
  },
  updated () {
    this.$store.commit('HIDE_Cart')
  },
  methods: {
    ...mapActions({
      updateCart: 'cart/updateCart',
      removeItemInCart: 'cart/removeItemInCart'
    }),
    updateQuantity (event) {
      if (this.timeOut) { clearTimeout(this.timeOut) }
      this.timeOut = setTimeout(() => {
        const vm = this
        this.updateCart({
          item: vm.checkProd(vm.product),
          qty: parseInt(event.target.value),
          isAdd: false
        })
      }, 1200)
    },
    addItem () {
      const prod = {
        item: Object.assign({}, this.product),
        qty: 1,
        isAdd: true
      }
      this.updateCart(prod)
      this.$store.commit('SHOW_Cart', true)
      this.$notify.show({
        text: 'Product added',
        type: 'success',
        closeWait: 2000
      })
    },
    passName (name) {
      return name.replace(/-/g, ' ')
    }
  },
  head () {
    return {
      title: `${this.product.name} | ${this.categoryName}`,
      meta: [
        { hid: 'og:title', name: 'og:title', content: `${this.product.name} | ${this.categoryName}` },
        { hid: 'description', name: 'description', content: `${this.product.name} | ${this.categoryName}` }
      ]
    }
  }
}
